import './styles.css';
import { Suspense } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { Admin, LoginCallback, Manager, LaundryManager } from "./layouts";
import { useUserContext } from "./context/userContext";
import { ClockLoader } from 'react-spinners';

const AppLoader = () => (
  <div className="w-full h-full fixed top-0 left-0 bg-white z-50 flex justify-center items-center">
    <ClockLoader color="#059669" />
  </div>
);

const DefaultRedirect = () => {
  const { isAuthenticated, isLoading, isAdmin, isLaundryManager, login } = useUserContext();

  if (isLoading) return <AppLoader />;

  if (isAuthenticated) {
    if (isAdmin) return <Navigate to="/admin/dashboard" replace />;
    if (isLaundryManager) return <Navigate to="/laundry-manager/laundry" replace />;
    return <Navigate to="/manager/dashboard" replace />;
  }

  login();
  return <AppLoader />;
};


const App = () => {

  const { isAdmin, isAuthenticated, isLaundryManager } = useUserContext();

  return (
    <Suspense fallback={<AppLoader />}>
      <Routes>
        {isAdmin && <Route path="/admin/*" element={<Admin />} />}
        {isAuthenticated && isLaundryManager && <Route path="/laundry-manager/*" element={<LaundryManager />} />}
        {isAuthenticated && !isLaundryManager && <Route path="/manager/*" element={<Manager />} />}
        <Route path="/login/callback" element={<LoginCallback />} />
        <Route path="*" element={<DefaultRedirect />} />
      </Routes>
    </Suspense>
  )
};

export default App;
